// Workflow actionType suffixes
export const actionTypeSuffixes = {
	begin: '_Begin',
	success: '_Success',
	fail: '_Fail'
}

// Generate an actionType
// - an object with a single entry with the correct key and string value
const actionTypeForName = name => ({ [name]: name })
//
// E.g.
// actionTypeForName('nounVerb')
// --> { nounVerb: 'nounVerb' }
//

// Generate workflow actionTypes, suffixed with '_Begin', '_Success' and '_Fail'
// - an array of single entry actionType objects
// - these actionTypes are used in workflow sagas
const workflowActionTypesForName = name => Object.values(actionTypeSuffixes).map(suffix => actionTypeForName(`${name}${suffix}`))
//
// E.g.
// workflowActionTypesForName('nounVerb')
// --> [ { nounVerbBegin: 'nounVerbBegin' }, { nounVerbSuccess: 'nounVerbSuccess' }, { nounVerbFail: 'nounVerbFail' } ]
//

// ActionType identifiers
// - a config object, determines which actionTypes should be generated
// Call the generate function with a name stub to create appropriate actionType objects or an arrays of them
// These can then be flattened and merged to form the exportable actionTypes object.
// Also used to identify which actionTypes need to be aggregated for workflow sagas

// An actionType with the string value being equal to the name
// - a single actionType object
// Equivalent to a normal, string valued actionType definition
export const basic = {
	generate: actionTypeForName
}
//
// E.g.
// basic.generate('nounVerb')
// --> { nounVerb: 'nounVerb' }
//

// A workflow actionType
// - an array of action typeObjects
// Like basic, with the regular string valued actionType definition, also has *_Begin, *_Success, *_Fail actionTypes
export const workflow = {
	generate: name => [actionTypeForName(name), ...workflowActionTypesForName(name)]
}
//
// E.g.
// workflow.generate('nounVerb')
// --> [ { nounVerb: 'nounVerb' }, { nounVerbBegin: 'nounVerbBegin' }, { nounVerbSuccess: 'nounVerbSuccess' }, { nounVerbFail: 'nounVerbFail' } ]
//



// WEBPACK FOOTER //
// ./src/redux/actionTypes/generators.js